


const onError = ( error ) => {
	console.error( error );
	return false;
}

export const asyncValidateWaterfall = async( validationCallbacks ) => {

	// Allow either Arrays or Function as Parameter.
	const callbacks = [].concat( validationCallbacks );
	let isValid = true;

	// Run through all validations, and build the chain for the checks in Order.
	for ( const callback of callbacks ) {

		// Resolve any kind of Callback, sync or async as promise.
		// Promises should return true if they are valid.
		isValid = isValid && await Promise.resolve( callback() ).catch( onError );
	}

	return isValid;
};

export const asyncValidateAll = async( validationCallbacks ) => {
	const promises = [].concat( validationCallbacks );
	return await Promise.all( promises ).then( results => results.every( el => !!el ) ).catch( onError );
};
